import { AuthTokens, User } from '../services/types/auth.types';

const ACCESS_TOKEN_COOKIE = 'access_token';
const REFRESH_TOKEN_COOKIE = 'refresh_token';
const TOKEN_EXPIRY_COOKIE = 'token_expiry';
const USER_DATA_KEY = 'user_data';

class TokenManager {
  setTokens(tokens: AuthTokens): void {
    try {
      const expiryTime = Date.now() + (tokens.expiresIn * 1000);
      
      localStorage.setItem(ACCESS_TOKEN_COOKIE, tokens.accessToken);
      localStorage.setItem(REFRESH_TOKEN_COOKIE, tokens.refreshToken);
      localStorage.setItem(TOKEN_EXPIRY_COOKIE, expiryTime.toString());
    } catch {
    }
  }

  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_COOKIE);
    } catch {
      return null;
    }
  }

  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_TOKEN_COOKIE);
    } catch {
      return null;
    }
  }

  isTokenExpired(): boolean {
    try {
      const expiryTime = localStorage.getItem(TOKEN_EXPIRY_COOKIE);
      if (!expiryTime) return true;
      
      return Date.now() >= parseInt(expiryTime);
    } catch {
      return true;
    }
  }

  hasValidTokens(): boolean {
    const accessToken = this.getAccessToken();
    const refreshToken = this.getRefreshToken();

    return !!(accessToken && refreshToken && !this.isTokenExpired());
  }


  hasRefreshToken(): boolean {
    const refreshToken = this.getRefreshToken();
    return !!refreshToken;
  }

  canAttemptAuth(): boolean {
    return this.hasValidTokens() || this.hasRefreshToken();
  }

  clearTokens(): void {
    try {
      localStorage.removeItem(ACCESS_TOKEN_COOKIE);
      localStorage.removeItem(REFRESH_TOKEN_COOKIE);
      localStorage.removeItem(TOKEN_EXPIRY_COOKIE);
      localStorage.removeItem(USER_DATA_KEY);
    } catch {
    }
  }

  setUser(user: User): void {
    try {
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(user));
    } catch {
    }
  }

  getUser(): User | null {
    try {
      const userData = localStorage.getItem(USER_DATA_KEY);
      if (!userData) return null;
      return JSON.parse(userData);
    } catch {
      return null;
    }
  }

  getTokens(): AuthTokens | null {
    try {
      const accessToken = this.getAccessToken();
      const refreshToken = this.getRefreshToken();
      const expiryTime = localStorage.getItem(TOKEN_EXPIRY_COOKIE);
      
      if (!accessToken || !refreshToken || !expiryTime) {
        return null;
      }

      const expiresIn = Math.max(0, Math.floor((parseInt(expiryTime) - Date.now()) / 1000));
      
      return {
        accessToken,
        refreshToken,
        expiresIn
      };
    } catch {
      return null;
    }
  }
}

export const tokenManager = new TokenManager();
